
const getPitchDataHtml = () => `
  <div>
    <p style="margin:0 0 8px 0;"><strong><u>Photos:</u></strong> {{promoPhotos}}</p>
    <p style="margin:0 0 8px 0;"><strong><u>Listening Link:</u></strong> {{linkToListen}}</p>
    <p style="margin:0 0 8px 0;"><strong><u>UPC:</u></strong> {{releaseUpc}}</p>
    <p style="margin:0 0 8px 0;"><strong><u>ISRC:</u></strong> {{trackIsrc}}</p>
    <p style="margin:0 0 8px 0;"><strong><u>Genre:</u></strong> {{mainGenre}}</p>
    <p style="margin:0 0 8px 0;"><strong><u>Mood:</u></strong> {{songMood}}</p>
    <p style="margin:0 0 8px 0;"><strong><u>Song Description:</u></strong> {{shortDescription}}</p>
    <p style="margin:0 0 8px 0;"><strong><u>Marketing Description:</u></strong> {{longDescription}}</p>
  </div>
`;

export default getPitchDataHtml;    